import { giphyDarkestGrey, giphyLightGrey } from '@giphy/js-brand'
import styled from 'styled-components'

export const Container = styled.div`
    background: ${giphyDarkestGrey};
    border-radius: 6px;
    box-sizing: border-box;
    color: ${giphyLightGrey};
    padding: 50px;
    position: relative;
    text-align: center;
`

export const Description = styled.p`
    margin: 0 auto 1em;
    text-align: inherit;
`

export const Title = styled.h1`
    color: #fff;
    font-size: 1.1em;
    font-weight: bold;
    margin-bottom: 1em;
`

export const Header = styled.div`
    ${Title}:last-child,
    ${Description}:last-child {
        margin-bottom: 2em;
    }
`

export const Sticker = styled.img`
    height: 80px;
    left: 50%;
    margin-left: -60px;
    object-fit: contain;
    pointer-events: none;
    position: absolute;
    top: -40px;
    width: 120px;
`
